import React from 'react';
import { PageSection, useGlobal } from '@rcg/ui-react';
import DisplayingFlights from '../FlightSummary/DisplayingFlights';
import useStyles from './index.styles';
import { getAirPhoneNumber, getSessionStorageItem } from '../../commons/utils';

const FlightsInfoContainer = ({ flightProfile }) => {
  const { renderContent } = useGlobal();
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState([]);

  const handleExpanded = (index) => {
    const cardStates = [...expanded];
    cardStates[index] = !expanded[index];
    setExpanded(cardStates);
  };
  const bookingInfo = getSessionStorageItem('current-booking');
  const title = renderContent('flightSummaryBookingAmendComponentTitle', 'Flights');
  const description = (
    <>
      {renderContent(
        'flightSummaryBookingAmendComponentDescription',
        'Your flights below are confirmed. For baggage and optional fees, please contact the airline.',
      )}{' '}
      <span className="phoneNumber">{getAirPhoneNumber(bookingInfo)}</span>.
    </>
  );
  return (
    <div className={classes.rootFlightsSummary}>
      <PageSection title={title} description={description}>
        <DisplayingFlights
          expanded={expanded}
          handleExpanded={handleExpanded}
          flightProfile={flightProfile}
        />
      </PageSection>
    </div>
  );
};

export default FlightsInfoContainer;
